const API_BASE_URI = import.meta.env.VITE_API_BASE_URI;
const FA_BASE_URL = import.meta.env.VITE_FA_API_URL;
const FP_BASE_URL = import.meta.env.VITE_FA_FP_URL;
const MT_BASE_URL = import.meta.env.VITE_MT_URL;

export const URLS = {
  API_BASE_URI,
  FA_BASE_URL,
  FP_BASE_URL,
  MT_BASE_URL,
};
